import React from "react";
import { db } from "../../config/firebase";
import { doc, deleteDoc } from "firebase/firestore";

function DeleteModal({setOpenDeleteModal, setReload, selectedGeolocation}) {

  function handleClick(e) {
    if (e.target.classList.contains('backdrop') || e.target.classList.contains('cancel')) {
      setOpenDeleteModal(false);
    }
  }

  async function deleteGeolocation() {
    const geolocation = doc(db, "geolocations", selectedGeolocation.id);
    await deleteDoc(geolocation);
    setOpenDeleteModal(false);
    setReload(prev => !prev);
  };

  return (
    <div className="backdrop" onClick={ handleClick }>
      <div className="card delete-modal text-bg-dark border-danger p-4">
        <h4 className="text-danger">Confirm deletion</h4>
        <p>Are you sure you want to delete this geolocation?</p>
        <div className="row">
          <div className="col">
            <button className="btn btn-sm btn-outline-light cancel" onClick={ handleClick }>
              No, cancel
            </button>
          </div>
          <div className="col">
            <button className="btn btn-sm btn-outline-danger float-end" onClick={ deleteGeolocation }>
              Yes, delete that shit
            </button>
          </div>
        </div>
        
      </div>
    </div>
  )
};

export default DeleteModal;